import { appInfo } from '@/mocks/siteData';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-4xl mx-auto px-4 md:px-6">
        <div className="bg-gradient-to-br from-foreground-900 to-foreground-800 rounded-2xl p-8 md:p-12 flex flex-col md:flex-row items-center gap-8 md:gap-12">
          <div className="flex-1 text-center md:text-left">
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-background-50 mb-4">
              下载 51电影网 APP
            </h2>
            <p className="text-foreground-300 text-sm leading-relaxed mb-6">{appInfo.desc}</p>
            <div className="flex flex-wrap gap-3 justify-center md:justify-start mb-6">
              {appInfo.features.map((f, i) => (
                <span key={i} className="text-xs px-3 py-1.5 bg-foreground-700/50 text-foreground-200 rounded-full border border-foreground-600/30 whitespace-nowrap">
                  {f}
                </span>
              ))}
            </div>
            <div className="flex flex-col sm:flex-row gap-3 justify-center md:justify-start">
              <button className="px-6 py-2.5 bg-primary-500 text-background-50 rounded-lg text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-apple-fill mr-1.5"></i> App Store
              </button>
              <button className="px-6 py-2.5 bg-background-50/10 text-background-50 rounded-lg text-sm font-medium hover:bg-background-50/20 transition-colors border border-background-50/20 whitespace-nowrap cursor-pointer">
                <i className="ri-android-fill mr-1.5"></i> Google Play
              </button>
            </div>
          </div>
          <div className="flex-shrink-0">
            <img
              src={appInfo.qrImage}
              alt="51电影网 APP 下载二维码"
              className="w-40 h-40 md:w-48 md:h-48 rounded-xl bg-background-50 p-2"
              title="扫描下载51电影网APP"
            />
          </div>
        </div>
      </div>
    </section>
  );
}